import { AriaRole, memo, ReactNode } from "react";
import cx from "classnames";

import styles from "./styles.module.css";
import useTableKeyboardNavigation from "./hooks/useKeyboardNavigation/useTableKeyboardNavigation";

type TableProps = {
  children: ReactNode;
  ariaLabel: string;
  layout?: "auto" | "fixed";
  // Defaults to `grid`; pass `treegrid` for hierarchical tables so rows can expose aria-level.
  role?: AriaRole;
};

const Table = ({ children, ariaLabel, layout = "fixed", role = "grid" }: TableProps) => {
  const props = useTableKeyboardNavigation();

  return (
    <div aria-label={ariaLabel} className={cx(styles.table, styles[layout])} role={role} {...props}>
      {children}
    </div>
  );
};

Table.displayName = "DS.Table";

export default memo(Table);
